<template>
  <div
    v-if="modalExcluir"
    class="modal-overlay"
  >
    <div class="modal-box">
      <div class="modal-header">
        <span class="modal-titulo">AVISO</span>
        <button
          class="modal-fechar"
          @click="modalExcluir = false"
        >
          ✕
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-icone">?</div>
        <p class="modal-texto">
          Tem certeza que deseja excluir<br />esta notícia?
        </p>
        <div class="modal-botoes">
          <button
            class="btn-modal-cancelar"
            @click="modalExcluir = false"
          >
            Não
          </button>
          <button
            class="btn-modal-confirmar"
            @click="confirmarExclusao"
          >
            Sim
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="page-wrapper">
    <Breadcrumb :items="breadcrumbItems" />

    <carregamento v-if="carregando" />

    <main
      class="main-content"
      v-else-if="noticia"
    >
      <div :class="{ 'noticia-layout': props.isAcceptance }">
        <div
          class="content-card"
          :class="{ 'noticia-main': props.isAcceptance }"
        >
          <div class="header-container">
            <h1 class="page-title">{{ noticia.titulo }}</h1>

            <div
              class="action-buttons-top"
              v-if="estouNaAcao && souCoordenador"
            >
              <button
                type="button"
                class="btn btn-excluir"
                @click="excluirNoticia"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path
                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                  ></path>
                  <line
                    x1="10"
                    y1="11"
                    x2="10"
                    y2="17"
                  ></line>
                  <line
                    x1="14"
                    y1="11"
                    x2="14"
                    y2="17"
                  ></line>
                </svg>
                Excluir
              </button>
              <button
                type="button"
                @click="irParaEditar"
                class="btn btn-editar"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  ></path>
                  <path
                    d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  ></path>
                </svg>
                Editar
              </button>
            </div>
          </div>

          <div class="info-row">
            <div class="info-item">
              <span class="info-label">Data de publicação:</span>
              <span class="info-date">{{
                formatarData(noticia.dataPublicacao)
              }}</span>
            </div>
            <div
              class="info-item"
              v-if="
                noticia.dataAtualizacao &&
                formatarData(noticia.dataAtualizacao) !==
                  formatarData(noticia.dataPublicacao)
              "
            >
              <span class="info-label">Atualização:</span>
              <span class="info-date highlight">{{
                formatarData(noticia.dataAtualizacao)
              }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Autor:</span>
              <span class="info-value">{{ noticia.autorPublicacaoNome }}</span>
            </div>
            <div
              class="info-item"
              v-if="noticia.palavrasChaves && noticia.palavrasChaves.length > 0"
            >
              <span class="info-label">Palavras-chave:</span>
              <span
                v-for="palavrasChave in noticia.palavrasChaves"
                :key="palavrasChave"
                class="tag"
              >
                {{ palavrasChave }}
              </span>
            </div>
          </div>

          <hr class="divider" />

          <div
            class="imagem-destaque-wrapper"
            v-if="noticia.imagemUrl"
          >
            <img
              :src="noticia.imagemUrl"
              alt="Imagem da notícia"
              class="imagem-destaque"
            />
            <p
              class="img-legenda"
              v-if="noticia.descricaoImagem"
            >
              {{ noticia.descricaoImagem }}
            </p>
          </div>

          <div class="noticia-texto-wrapper">
            <div
              v-if="noticia.texto"
              class="texto-noticia"
              v-html="noticia.texto"
            ></div>
          </div>

          <div
            v-if="noticia.editada"
            class="modificada-info"
          >
            Modificada em: {{ formatarData(noticia.dataEdicao) }}
          </div>
        </div>

        <aside
          v-if="props.isAcceptance"
          class="acceptance-sidebar"
        >
          <h3>Validar Notícia</h3>
          <p>
            Revise o conteúdo da notícia antes de autorizar a publicação no
            portal.
          </p>

          <div class="sidebar-buttons">
            <button
              class="btn-accept"
              @click="aceitarNoticia"
              :disabled="processando"
            >
              {{ processando ? "Processando..." : "Aceitar Notícia" }}
            </button>
            <button
              class="btn-reject"
              @click="rejeitarNoticia"
              :disabled="processando"
            >
              {{ processando ? "Processando..." : "Rejeitar Notícia" }}
            </button>
            <button
              class="btn-back"
              @click="router.back()"
            >
              Voltar
            </button>
          </div>
        </aside>
      </div>
    </main>

    <div
      v-else
      class="erro-container"
    >
      <div class="content-card">
        <p>Notícia não encontrada.</p>
      </div>
    </div>
  </div>

  <transition name="toast">
    <div
      v-if="toastMsg"
      class="toast-notification"
    >
      {{ toastMsg }}
    </div>
  </transition>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { formatarData } from "@/utils/FormatarEntradas";
import noticiaService from "@/service/noticiaService";
import router from "@/router";
import { useRoute } from "vue-router";
import acaoService from "@/service/acaoService";
import userInfos from "@/utils/userInfos";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const emit = defineEmits(["titulo", "fechar-noticia"]);
const noticia = ref(null);
const route = useRoute();
const btnCopy = ref("Copiar link");
const carregando = ref(true);
const processando = ref(false);
const dadosAcao = ref({});
const estouNaAcao = ref(false);
const souCoordenador = ref(false);
const toastMsg = ref("");
const props = defineProps({
  noticiaId: String,
  id: String,
  isAcceptance: Boolean,
});

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;
  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Notícias", to: `/acao/${acaoId}/noticias` },
      {
        label: noticia.value?.titulo || "Notícia",
        to: `/acao/${acaoId}/noticias/${props.noticiaId}`,
      },
    ];
  } else {
    return [
      { label: "Início", to: "/" },
      { label: "Noticias", to: "/noticias" },
      {
        label: noticia.value?.titulo || "Notícia",
        to: `/noticias/${props.noticiaId}`,
      },
    ];
  }
});

function mudarRota() {
  router.back();
}

const modalExcluir = ref(false);

function excluirNoticia() {
  if (!noticia.value) return;
  modalExcluir.value = true;
}

async function confirmarExclusao() {
  modalExcluir.value = false;
  try {
    await noticiaService.excluirNoticia(noticia.value.id);
    alert("Notícia excluída com sucesso!");
    router.back();
  } catch (error) {
    console.error("Erro ao excluir notícia:", error);
    alert("Não foi possível excluir a notícia. Tente novamente.");
  }
}

async function carregarNoticia(id) {
  if (!id) return;
  try {
    carregando.value = true;
    noticia.value = null;
    const response = await noticiaService.getNoticiaById(id);
    if (response) {
      noticia.value = response;
    }
  } catch (error) {
    console.error("Erro ao carregar notícia:", error);
    noticia.value = null;
  } finally {
    carregando.value = false;
  }
}

function irParaEditar() {
  if (!noticia.value) return;
  router.push({
    name: "editar-noticia",
    params: {
      id: route.params.id,
      noticiaId: noticia.value.id,
    },
  });
}
async function aceitarNoticia() {
  if (!noticia.value) return;
  try {
    processando.value = true;
    await noticiaService.autorizarNoticia(noticia.value.id, true);
    showToast("Notícia autorizada com sucesso!");
    setTimeout(() => router.back(), 1500);
  } catch (error) {
    console.error("Erro ao aceitar notícia:", error);
  } finally {
    processando.value = false;
  }
}

async function rejeitarNoticia() {
  if (!noticia.value) return;
  // const motivo = prompt("Por favor, informe o motivo da rejeição:");
  // if (motivo === null) return; // Usuário cancelou o prompt
  const motivo =
    "Notícia rejeitada pelo administrador. Entre em contato para mais detalhes.";

  try {
    processando.value = true;
    // Agora usando a mesma rota de autorização, mas com autorizado: false
    await noticiaService.autorizarNoticia(noticia.value.id, false, motivo);
    showToast("Notícia rejeitada com sucesso!");
    setTimeout(() => router.back(), 1500);
  } catch (error) {
    console.error("Erro ao rejeitar notícia:", error);
  } finally {
    processando.value = false;
  }
}

function showToast(msg) {
  toastMsg.value = msg;
  setTimeout(() => (toastMsg.value = ""), 2500);
}

function shareInstagram() {
  const url = window.location.origin + route.fullPath;
  navigator.clipboard
    .writeText(url)
    .then(() => showToast("Link copiado! Cole no Instagram Stories ou na bio."))
    .catch(() => showToast("Não foi possível copiar. Tente manualmente."));
}

function shareTwitter() {
  const text = encodeURIComponent(
    "Confira esta notícia do GEx — Pró-Reitoria de Extensão da UFC!"
  );
  const url = encodeURIComponent(window.location.origin + route.fullPath);
  window.open(
    `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
    "_blank",
    "noopener,noreferrer"
  );
}

function copyLink() {
  const fullUrl = window.location.origin + route.fullPath;
  navigator.clipboard
    .writeText(fullUrl)
    .then(() => {
      btnCopy.value = "Copiado";
      setTimeout(() => {
        btnCopy.value = "Copiar link";
      }, 2000);
    })
    .catch(() => alert("Não foi possível copiar. Tente novamente!"));
}

watch(
  () => props.noticiaId || route.params.noticiaId,
  async (id) => {
    if (id) await carregarNoticia(id);
  },
  { immediate: true }
);

async function verificarCoordenador() {
  try {
    const acaoId = route.params.id;
    if (!acaoId) return;

    souCoordenador.value = await acaoService.verificarCoordenador(acaoId);
  } catch (error) {
    console.error("Erro ao verificar coordenação:", error);
  }
}

onMounted(async () => {
  carregando.value = true;
  if (route.params.id) {
    dadosAcao.value = await acaoService.getAcoesById(route.params.id);
    estouNaAcao.value = true;
    await verificarCoordenador();
  }
  carregando.value = false;
});
</script>

<style scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
  margin: 0;
  padding: 0;
}

.content-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-height: 50vh;
  padding: 32px 40px;
  margin: 10px 0 30px 0;
}

.noticia-layout {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.noticia-main {
  flex: 1;
  width: 100%;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 16px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.3;
}

.action-buttons-top {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn:active {
  transform: scale(0.97);
}

.btn-excluir {
  background: #fff;
  border: 1.5px solid #dc2626;
  color: #dc2626;
}

.btn-excluir:hover {
  background: #dc2626;
  color: #fff;
}

.btn-editar {
  background: #3b2078;
  color: #fff;
}

.btn-editar:hover {
  background: #4c2d99;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.info-date {
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 2px 10px;
  color: #444;
  background: #fafafa;
}

.info-date.highlight {
  border-color: #3b2078;
  color: white;
  background: #772fa2;
  font-weight: 600;
}

.info-value {
  font-size: 13px;
  color: #555;
}

.divider {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 0 0 24px 0;
}

.imagem-destaque-wrapper {
  margin-bottom: 30px;
  text-align: center;
  width: 100%;
}

.imagem-destaque {
  max-width: 100%;
  max-height: 450px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.img-legenda {
  font-size: 13px;
  color: #666;
  margin: 10px 0 0 0;
  font-style: italic;
}

.noticia-texto-wrapper {
  color: #1f2937;
  font-size: 16px;
  line-height: 1.8;
  text-align: left;
}

.texto-noticia {
  font-family: "Inter", "Roboto", "Arial", sans-serif;
}

.texto-noticia p {
  margin-bottom: 1.2rem;
}

.texto-noticia img {
  max-width: 100%;
  border-radius: 6px;
}

.modificada-info {
  margin-top: 30px;
  padding-top: 12px;
  border-top: 1px dashed #e5e7eb;
  font-size: 12.5px;
  color: #6b7280;
  font-style: italic;
}

.tag-icon {
  color: #3b2078;
  flex-shrink: 0;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  border: 1px solid hsl(255, 40%, 75%);
  border-radius: 16px;
  padding: 4px 14px;
  color: #3b2078;
  background: hsl(255, 50%, 97%);
  font-weight: 500;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tag:hover {
  background: hsl(255, 50%, 93%);
  border-color: #3b2078;
}

.acceptance-sidebar {
  width: 320px;
  background-color: #ffffff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.acceptance-sidebar h3 {
  margin: 0;
  color: #3b2078;
  font-size: 18px;
  font-weight: 700;
}

.acceptance-sidebar p {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
  margin: 0;
}

.sidebar-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.btn-accept {
  padding: 10px;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-accept:hover {
  background-color: #059669;
}

.btn-reject {
  padding: 10px;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-reject:hover {
  background-color: #dc2626;
}

.btn-back {
  padding: 10px;
  background-color: transparent;
  color: #4b5563;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-back:hover {
  background-color: #f3f4f6;
}

.btn-accept:disabled,
.btn-reject:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 1rem;
  color: #6b7280;
}

.spinner {
  width: 38px;
  height: 38px;
  border: 4px solid #f3f4f6;
  border-top-color: #772fa2;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.erro-container {
  text-align: center;
  padding: 3rem 2rem;
  color: #4b5563;
}

.erro-container p {
  font-size: 16px;
  margin: 0;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: #ffffff;
  border-radius: 8px;
  width: 340px;
  overflow: hidden;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.modal-header {
  background: #3b2078;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.modal-titulo {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.05em;
}

.modal-fechar {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.modal-icone {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f0eaff;
  color: #772fa2;
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-texto {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

.modal-botoes {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
  margin-top: 8px;
}

.btn-modal-cancelar {
  padding: 8px 24px;
  border-radius: 6px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  color: #4b5563;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-modal-cancelar:hover {
  background: #f3f4f6;
}

.btn-modal-confirmar {
  padding: 8px 24px;
  border-radius: 6px;
  border: none;
  background: #ef4444;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-modal-confirmar:hover {
  background: #dc2626;
}

.toast-notification {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #3b2078;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 2000;
  font-weight: 600;
  font-size: 14px;
}

.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(16px);
}

@media (max-width: 768px) {
  .noticia-layout {
    flex-direction: column;
  }
  .content-card {
    padding: 24px 20px;
  }
  .header-container {
    flex-direction: column;
    gap: 12px;
  }
  .action-buttons-top {
    width: 100%;
    justify-content: flex-start;
  }
  .acceptance-sidebar {
    width: 100%;
    position: static;
  }
}
</style>
